<template>
  <div>
    <div class="col-lg-12 m-0 p-0">
      <card type="chart">
        <template slot="header">
          <div class="row">
            <div class="col-sm-6">
              <h2 class="card-title d-inline" title="U.S. COVID Risk Tracker">
                U.S. COVID Risk Tracker
              </h2>
              <el-tooltip
                content="Covid Act Now uses five key metrics to assess COVID across U.S. states, metros, and counties. Three of these—daily new cases (incidence), infection rate (RT) and positive test rate—assess a location's overall risk level."
                effect="dark"
                :open-delay="300"
                placement="top"
              >
                <base-button type="link">
                  <i
                    class="fa fa-info-circle text-info fa-2x info-cursor pl-1 mb-2"
                  ></i>
                </base-button>
              </el-tooltip>
            </div>
          </div>
        </template>
        <div>
          <div
            id="container"
            style="
              height: 500px;
              min-width: 300px;
              max-width: 900px;
              margin: 0 auto;
            "
          ></div>
        </div>
        <div class="text-center mainscorebox" v-show="renderedMap">
          <section class="smallbox pt-3" style="width: 250px">
            <span class="pr-1 pt-1 text-white"><b>Low</b> risk</span>
            <div
              v-for="(color, index) in mapColor"
              class="smallsection"
              :key="color"
            >
              <div
                :style="'background-color:' + color"
                style="height: 28px"
                :class="'border' + index"
              ></div>
            </div>
            <span class="pl-1 pt-1 text-white"><b>Severe</b> risk</span>
          </section>
        </div>
      </card>
    </div>

    <div class="col-lg-12 m-0 p-0">
      <card type="chart">
        <template slot="header">
          <div class="row">
            <div class="col-sm-6">
              <h2
                class="card-title d-inline"
                title="Key COVID-19 Metrics by State"
              >
                Key COVID-19 Metrics by State
              </h2>
              <el-tooltip
                content="Covid Act Now uses five key metrics to assess COVID across U.S. states, metros, and counties. Three of these—daily new cases (incidence), infection rate (RT) and positive test rate—assess a location's overall risk level."
                effect="dark"
                :open-delay="300"
                placement="top"
              >
                <base-button type="link">
                  <i
                    class="fa fa-info-circle text-info fa-2x info-cursor pl-1 mb-2"
                  ></i>
                </base-button>
              </el-tooltip>
            </div>
          </div>
        </template>
        <div class="p-2" style="min-height: 500px">
          <table class="table table-responsive datatablemap">
            <thead v-show="renderedTable">
              <tr>
                <th
                  v-for="(column, index) in columns"
                  @click="
                    activeColumn = column;
                    sortBy(
                      index,
                      activeColumn.name,
                      activeColumn.order == 'asc' ? 'desc' : 'asc',
                      column.orderable
                    );
                  "
                  :class="[
                    {
                      active: column == activeColumn,
                      orderable: column.orderable,
                      textright:index!==0
                    },
                  ]"
                  :key="column.name"
                >
                  {{ colTitles[column.name] }}
                  <span
                    v-show="column.orderable"
                    class="arrow"
                    :class="column.order == 'asc' ? 'asc' : 'dsc'"
                  ></span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in exitData" :key="item.name">
                <td
                  :style="
                    'background-color:' + mapColor[item.risk_levels_overall]
                  "
                >
                  {{ item.name }}
                </td>
                <td class="text-right">
                  <span v-if="item.case_density !== ''" class="m-0">
                    {{ format(item.case_density) }}
                  </span>
                </td>
                <td class="text-right">
                  <span v-if="item.new_cases !== ''" class="m-0">
                    {{ format(item.new_cases) }}
                  </span>
                </td>
                <td class="text-right">
                  <span v-if="item.vaccinations_initiated !== ''" class="m-0">
                    {{ format(item.vaccinations_initiated) }}
                  </span>
                </td>
                <td class="text-right">
                  <span v-if="item.deaths !== ''" class="m-0">
                    {{ format(item.deaths) }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import * as chartConfigsH from "@/components/Charts/HighchartConfig";
import * as chartConfigs from "@/components/Charts/config";
import Micro from "@/pages/Dashboard/Micro.vue";
import axios from "axios";
import moment from "moment";
import lodash from "lodash";
const options = chartConfigsH.config;
const removeState = chartConfigs.removeState;
export default {
  data() {
    return {
      activeColumn: {},
      columns: [],
      colTitles: {
        name: "STATE",
        case_density: "New cases per 100K per day",
        new_cases: "New cases per day",
        vaccinations_initiated: "Vaccinations Initiated",
        deaths: "Deaths",
      },
      exitPulldate: "",
      exitPullTime: "",
      exitData: [],
      renderedTable: false,
      renderedMap: false,
      mapOptions: {},
      mapColor: ["#02d377", "#fec900", "#ff9600", "#d8012c", "#79001a"],
    };
  },
  components: { Micro },
  mounted() {
    var self = this;
    this.columnData();
    this.setTheme();
    axios.get(process.env.VUE_APP_API_URL + "/mapdata").then((response) => {
        var origianlData = response.data
          .filter((value) => !removeState.includes(value.state.trim()))
          .map((o) => {
            o.state = o.state.trim();
            return o;
          });
        //update datasource pull data time
        self.exitPulldate = moment
          .utc(origianlData[0].updated)
          .local()
          .format("M/D");
        self.exitPullTime = moment
          .utc(origianlData[0].updated)
          .local()
          .format("h:mm A");
        $("#exitDate").empty().append(self.exitPulldate);
        $("#exitTime").empty().append(self.exitPullTime);
        var data = [];
        // Set drilldown pointers
        for (var i = 0; i < origianlData.length; i++) {
          var dataset = origianlData[i];
          var temp = {};
          temp.name = dataset.state.trim();
          temp.code = chartConfigs.states_hash[dataset.state.trim()];
          temp.risk_levels_overall = dataset.risk_levels_overall;
          temp.color = this.mapColor[dataset.risk_levels_overall];
          temp.case_density = dataset.case_density
            ? parseFloat(dataset.case_density).toFixed(2)
            : "";
          temp.deaths = dataset.deaths ? dataset.deaths : 0;
          temp.vaccinations_initiated = dataset.vaccinations_initiated
            ? parseFloat(dataset.vaccinations_initiated).toFixed(2)
            : "";
          temp.new_cases = dataset.new_cases ? dataset.new_cases : "";
          temp.new_cases1 = dataset.new_cases
            ? this.format(dataset.new_cases)
            : "";
          temp.icubeds_typical_usage_rate = dataset.icubeds_typical_usage_rate
            ? this.format(dataset.icubeds_typical_usage_rate)
            : "";

          data.push(temp);
        }
        self.exitData = [...data];
        self.renderMap(data);
        self.renderDataTable(data);
        self.activeColumn = {
          name: "case_density",
          order: "asc",
          orderable: true,
        };
        self.sortBy(1, "case_density", "desc", true);
      });
  },
  methods: {
    format(txt) {
      var num_parts = txt.toString().split(".");
      num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      //num_parts.join(".");
      return num_parts[0];
    },
    //reset this very important to show sort arrow correct way
    columnData() {
      this.columns = [
        { name: "name", order: "asc", orderable: true },
        {
          name: "case_density",
          order: "asc",
          orderable: true,
        },
        { name: "new_cases", order: "asc", orderable: true },
        {
          name: "vaccinations_initiated",
          order: "asc",
          orderable: true,
        },
        { name: "deaths", order: "asc", orderable: true },
      ];
    },
    sortBy: function (index, columnname, order, orderable) {
      if (!orderable) return;
      this.exitData = lodash.orderBy(
        this.exitData,
        function (o) {
          var n = o[columnname];
          if (/^\d+\.\d+$/.test(n)) {
            return parseFloat(o[columnname]);
          } else if (parseInt(n) == n) {
            return parseInt(o[columnname]);
          } else {
            return o[columnname];
          }
        },
        order
      );

      this.columnData();
      this.activeColumn.order =
        this.activeColumn.order == "asc" ? "desc" : "asc";
      this.columns[index] = this.activeColumn;
    },
    renderDataTable(data) {
      this.renderedTable = true;
    },
    renderMap(data) {
      var self = this;
      // Instanciate the map.mapChart('world-map',
      Highcharts.mapChart("container", {
        chart: {
          events: {},
          map: "countries/us/us-all",
          scrollablePlotArea: {
            minWidth: 600,
            scrollPositionX: 1,
            opacity: 0,
          },
        },
        title: {
          text: "",
        },
        legend: {
          enabled: false,
        },
        mapNavigation: {
          enabled: false,
          buttonOptions: {
            verticalAlign: "bottom",
          },
        },

        plotOptions: {
          map: {
            states: {
              hover: {
                enabled: false,
                color: "#EEDD66",
              },
            },
          },
        },
        colorAxis: {
          min: 0,
          minColor: "#E6E7E8",
          maxColor: "#005645",
        },
        series: [
          {
            data: data,
            joinBy: ["postal-code", "code"],
            dataLabels: {
              enabled: false,
              pointFormat: "{point.name}",
            },
            tooltip: {
              useHTML: true,
              headerFormat: "<b>{point.name}</b><br>",
              pointFormat:
                "<b>{point.name}</b>" +
                "<br/>New Cases: {point.new_cases1}" +
                "<br/>ICU utilization: {point.icubeds_typical_usage_rate}",
            },
          },
        ],
      });
      self.renderedMap = true;
    },
    setTheme() {
      Highcharts.theme = options;
      // Apply the theme
      Highcharts.setOptions(Highcharts.theme);
    },
  },
};
</script>
 <style scoped>
table {
  table-layout: fixed;
}
.progress {
  border-radius: 0;
  height: 1rem;
}
.map {
  min-height: 500px;
}
.scorebox {
  padding: 5px 30px;
}
@media (min-width: 961px) {
  .mainscorebox {
    padding-top: 20px;
    width: 90%;
    margin: 0 auto;
  }
  .table-responsive {
    display: table !important;
  }
}
.table-responsive {
  display: block;
}
.text-section {
  margin-bottom: 10px;
}
.smallbox {
  display: flex;
  margin: 0 auto;
}
.smallsection {
  flex-grow: 1;
}
.border0 {
  border-top-left-radius: 50px;
  border-bottom-left-radius: 50px;
}
.border4 {
  border-top-right-radius: 50px;
  border-bottom-right-radius: 50px;
}
.textright{
  text-align: right;
}
</style>
